export default __webpack_public_path__ + "static/potted plant-8e7ee104872fda25d836a27a84f22092.png";